import React from 'react';
import { SelectField, OptionField } from './../../../../components/ui/input';
import { EmailService } from './../../../../services';

class EmailLayoutSelect extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      entities: []
    };
  };

  /**
  * @Event
  * @Description: Is invoked immediately after a component is mounted.
  */
  componentDidMount(){
    this._All();
  };

  /*
  ** @Service
  ** @Description: List all templates
  */

  _All = () => {
    EmailService.findLayouts().then((response) => {
      this.setState({ entities: response.layouts || [] });
    });
  };

  render() {

    const { entities } = this.state;

    return(
      <SelectField { ...this.props }>
        { entities.length > 0 ? (
          <React.Fragment>
            <OptionField value="-1">Seleccionar...</OptionField>
            { entities.map((entity, index) => {
              return(
                <OptionField key={ index } value={ entity._id }>
                  { entity.name }
                </OptionField>
              )
            })}
          </React.Fragment>
        ) : (
          <OptionField value="-1">Cargando...</OptionField>
        )}
      </SelectField>
    )
  }

};

export default EmailLayoutSelect;
